<template>
  <div>
    <div class="row items-center justify-between">
      <div class="text-accent text-weight-bold q-pa-sm">
        {{ totalProduct }} {{ t("products") }}
      </div>
      <div>
        <q-btn
          :disable="items.docs.length === 0"
          no-caps
          dense
          unelevated
          class="text-weight-bold"
          color="primary"
          flat
          :label="t('remove_all')"
          @click="clearCart"
        />
      </div>
    </div>
    <q-card
      v-for="(item, index) in items.docs"
      :key="'job-' + index"
      flat
      bordered
      class="q-mb-sm row"
    >
      <q-btn
        dense
        flat
        round
        :icon="mdiClose"
        color="primary"
        class="absolute-top-right"
        size="sm"
        @click="removeItem(item._id)"
        style="z-index: 2"
      />
      <q-item class="q-pa-sm full-width">
        <div
          avatar
          class="border-radius-10 row justify-center items-center"
          style="
            height: 50px;
            width: 50px;
            border: 1px solid gray;
            overflow: hidden;
          "
        >
          <q-img
            :src="
              getImageFullPath(
                item?.product_thumbnail || item?.product?.gallery[0]
              )
            "
            style="height: 40px; width: 40px; object-fit: contain"
          />
        </div>

        <div
          class="col q-mx-sm"
          style="
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          "
        >
          <div class="row q-col-gutter-sm line-height-1 font-size-12">
            <div v-html="item.product_name"></div>
            <div
              v-for="attribute in item.attributes"
              class="text-dark"
              :key="attribute.attribute_name"
            >
              {{ attribute.attribute_name }}: {{ attribute.value }}
            </div>
          </div>
          <div class="text-caption ellipsis line-height-1 text-accent">
            <div class="font-size-12">
              <div v-if="item.sale_price" class="row items-center">
                <span class="text-primary text-weight-bold">
                  {{ formatCurrency(item.sale_price || 0) }}
                </span>
                <span class="text-caption text-grey-6 text-strike q-ml-xs">
                  {{ formatCurrency(item.price || 0) }}
                </span>
              </div>
              <div v-else class="text-caption text-accent">
                {{ formatCurrency(item.price || 0) }}
              </div>
            </div>
            <div class="font-size-10">
              {{ removeHtmlTags(item.category_name || "") }}
            </div>
          </div>
        </div>

        <div class="q-mr-sm">
          <div class="text-center text-primary text-weight-bold">
            {{
              formatCurrency(
                Number(item.quantity) *
                  (Number(item.sale_price || item.price) || 0)
              )
            }}
          </div>
          <!-- <quantity :quantity="getQuantity(item.price_id?._id ?? item.product._id)"
            @increase="increaseQty(item.price_id?._id ?? item.product._id)"
            @decrease="decreaseQty(item.price_id?._id ?? item.product._id)" /> -->
          <div
            class="row items-center no-wrap"
            style="border-radius: 14px; border: 1px solid grey; padding: 3px"
          >
            <q-btn
              :icon="mdiMinus"
              round
              dense
              flat
              @click="decrease(item)"
              color="white"
              size="xs"
              class="bg-dark"
            />
            <div class="q-px-sm">{{ item.quantity }}</div>
            <q-btn
              :icon="mdiPlus"
              round
              dense
              flat
              @click="increase(item)"
              color="white"
              size="xs"
              class="bg-dark"
            />
          </div>
        </div>
      </q-item>
    </q-card>
  </div>
</template>

<script setup lang="ts">
import { useLang } from "@/composables/useLang";
import type { ICartItem } from "@/types/cart";
import type { BaseResponsePagination } from "@/types/models";
import { formatCurrency } from "@/utils/currencyUtil";
import { getImageFullPath, removeHtmlTags } from "@/utils/appUtil";
import type { PropType } from "vue";
import { computed } from "vue";
import { mdiClose, mdiMinus, mdiPlus } from "@quasar/extras/mdi-v7";

const props = defineProps({
  items: {
    type: Object as PropType<BaseResponsePagination<ICartItem>>,
    required: true
  }
});

const totalProduct = computed(() => props.items.totalDocs);

const { t } = useLang();
const emit = defineEmits<{
  (e: "removeItem", id: string): void;
  (e: "clearCart"): void;
  (e: "updateQuantity", payload: { id: string; quantity: number }): void;
}>();

const removeItem = (id: string) => {
  emit("removeItem", id);
};

const clearCart = () => {
  emit("clearCart");
};
const increase = async (item: ICartItem) => {
  const quantity = item.quantity + 1;
  emit("updateQuantity", { id: item._id, quantity });
};

const decrease = async (item: ICartItem) => {
  const quantity = item.quantity - 1;
  if (quantity >= 0) {
    emit("updateQuantity", { id: item._id, quantity });
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 200px;
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid #ccc;
}

#map {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
